<template>
    <div class="flex" :class="isCustomer ? 'justify-end' : 'justify-start'">
        <div class="max-w-[85%] sm:max-w-[75%]">
            <div class="flex items-baseline gap-2 mb-1" :class="isCustomer ? 'flex-row-reverse' : ''">
                <span class="text-xs font-medium text-slate-600 dark:text-slate-300">
                    {{ message.author_name }}
                </span>
                <span class="text-xs text-slate-400 dark:text-slate-500">{{ sentAt }}</span>
            </div>

            <!-- Payment request entries get the payment card, with an optional note -->
            <div v-if="message.kind === 'payment_request' && paymentRequest" class="space-y-2">
                <div
                    v-if="message.body"
                    v-safe-html="message.body_html"
                    class="rounded-lg px-4 py-3 text-sm whitespace-pre-line break-words [&_a]:underline bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-100"
                ></div>
                <PaymentRequestCard
                    :payment-request="paymentRequest"
                    :paying="paying"
                    :can-pay="canPay"
                    @pay="$emit('pay', paymentRequest)"
                />
            </div>

            <!-- Plain message bubble (attachment-only messages have no body) -->
            <div
                v-else-if="message.body"
                v-safe-html="message.body_html"
                class="rounded-lg px-4 py-3 text-sm whitespace-pre-line break-words [&_a]:underline"
                :class="
                    isCustomer
                        ? 'bg-orange-500 text-white'
                        : 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-100'
                "
            ></div>

            <ul
                v-if="message.attachments?.length"
                class="mt-2 flex flex-col gap-1.5"
                :class="isCustomer ? 'items-end' : 'items-start'"
            >
                <li v-for="attachment in message.attachments" :key="attachment.id" class="max-w-full">
                    <a
                        :href="attachment.download_url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-xs text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                    >
                        <Icon icon="paperclip" class="w-3.5 h-3.5 shrink-0" />
                        <span class="truncate" :title="attachment.name">{{ attachment.name }}</span>
                        <span class="shrink-0 text-slate-500 dark:text-slate-400">{{ formatSize(attachment.size) }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import PaymentRequestCard from '@/components/award-bookings/payment-request-card.vue';
import Icon from '@/components/ui/icon/icon.vue';
import { formatFileSize as formatSize } from '@/utils/format-file-size';

const props = defineProps({
    message: { type: Object, required: true },
    paymentRequest: { type: Object, default: null },
    paying: { type: Boolean, default: false },
    canPay: { type: Boolean, default: true },
});

defineEmits(['pay']);

const isCustomer = computed(() => props.message.author_role === 'customer');

const sentAt = computed(() =>
    new Date(props.message.created_at).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    })
);
</script>
